(function (app) {
  $(document).ready(function () {

    app.InsightPostingTimes = function () {

      var _this = this;

      var nameSpace = 'InsightPostingTimes',
        context = '.page__insight-posting-times--container'
        ;

      /**
       *
       * @param url
       * @param callback
       * @returns {*}
       */
      _this.get = function (url, callback) {
        var query = $.Deferred();
        var appTransport = app.transport();

        appTransport
          .setEvent('onSuccess', function (response) {
            callback(response);
            return query.resolve(response);
          })
          .setEvent('onError', function (error) {
            app.flashMessenger('error', error.code + ' :: ' + error.message.message);
            return query.reject(error);
          })
          .setEvent('onComplete', function () {

          })
        ;
        appTransport.get(url);
        return query.promise();
      };


      _this.getUrl = function (url, category) {
        if (_.isUndefined(category)) {
          return url;
        } else {
          return url + '?' + 'category=' + category;
        }

      };

      /**
       * Get days of the week
       */
      _this.getDays = function (category) {
        var $dataBody = $('.posting-times-days__body', $(context));
        $dataBody.html('');
        $dataBody.addClass('m-progress');
        _this.get(_this.getUrl('/api/insight/posting-times-days', category), function (response) {
          $dataBody.removeClass('m-progress');
          var dataRow = _.template(app.templates["Insight__posting-times____days-time"]);
          var $dataRow = $(
            dataRow(
              $.extend(response, {})
            )
          );
          $dataRow.appendTo($dataBody);

          if (_.isEmpty(response['yours'])) {
            dataRow = _.template(app.templates["Insight__text____no-records"]);
            $dataRow = $(
                dataRow(
                )
            );
            $dataRow.appendTo($dataBody.find('.yours-data'));
          }

        })
      };

      /**
       * Get time frames
       */
      _this.getTime = function (category) {
        var $dataBody = $('.posting-times-time__body', $(context));
        $dataBody.html('');
        $dataBody.addClass('m-progress');
        _this.get(_this.getUrl('/api/insight/posting-times-time', category), function (response) {
          $dataBody.removeClass('m-progress');
          var dataRow = _.template(app.templates["Insight__posting-times____days-time"]);
          var $dataRow = $(
            dataRow(
              $.extend(response, {})
            )
          );
          $dataRow.appendTo($dataBody);

          if (_.isEmpty(response['yours'])) {
            dataRow = _.template(app.templates["Insight__text____no-records"]);
            $dataRow = $(
                dataRow(
                )
            );
            $dataRow.appendTo($dataBody.find('.yours-data'));
          }
        })
      };

      _this.lastUpdatedToUserTimezone = function() {
        var $lastUpdated = $('[data-last-updated]');
        var lastUpdated = $lastUpdated.attr('data-last-updated');
        lastUpdated = app.utcToUserTimezone(lastUpdated);
        $lastUpdated.text(lastUpdated);
      };

      return {
        init: function () {
          _this.lastUpdatedToUserTimezone();

          _this.getDays();
          _this.getTime();

          $(document).off('change.search__' + nameSpace).on('change.search__' + nameSpace, context + ' select[name=category]', function (e) {

            var category = $(this).val();
            _this.getDays(category);
            _this.getTime(category);
          });

        }
      };
    };
  });
})(PreBuilt);
